/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavFullWidthDropdownContent_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNavDropdownContent_navigationModule$ref: FragmentReference;
export type SiteNavDropdownContent_navigationModule = {|
  +$fragmentRefs: SiteNavFullWidthDropdownContent_navigationModule$ref,
  +$refType: SiteNavDropdownContent_navigationModule$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SiteNavDropdownContent_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNavFullWidthDropdownContent_navigationModule",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6788e5c7159e3ce2bdd9f639559bc961';
module.exports = node;
